import initFetchPonyfill from 'fetch-ponyfill';
import deepmerge from 'deepmerge';
import PromisePolyfill from 'es6-promise';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var promisePonyfill = typeof Promise !== 'undefined' && Promise || PromisePolyfill;

var getFetchOptions = function getFetchOptions(_ref) {
  var fetchOpts = _ref.fetchOpts,
      payload = _ref.payload,
      experimentData = _ref.experimentData;
  return deepmerge(fetchOpts, {
    body: JSON.stringify(payload),
    headers: _objectSpread2({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, experimentData),
    method: 'POST'
  });
};

var makeRequest = function makeRequest(_ref2) {
  var fetchClient = _ref2.fetchClient,
      fetchOpts = _ref2.fetchOpts,
      url = _ref2.url,
      payload = _ref2.payload,
      experimentData = _ref2.experimentData;
  var fetchOptions = getFetchOptions({
    fetchOpts: fetchOpts,
    payload: payload,
    experimentData: experimentData
  });
  return fetchClient(url, fetchOptions).then(function (response) {
    // overt error: bad HTTP response
    if (!response.ok) {
      return response.text().then(function (text) {
        return promisePonyfill.reject(new Error("STATUS ".concat(response.status, ": ").concat(text)));
      }, function (error) {
        return promisePonyfill.reject(error);
      });
    }

    return response.text();
  }).then(function (text) {
    if (text === '') {
      return {};
    }

    return JSON.parse(text);
  }) // service-level error reported in the response body
  .then(function (response) {
    if (response.status && response.status >= 400) {
      var error = response.error ? new Error(response.error) : new Error(JSON.stringify(response));
      error.status = response.status;
      return promisePonyfill.reject(error);
    }

    return response;
  });
};

// an isomorphic base64 decoding pattern modified from:
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_4
var parseQueryString = function parseQueryString(query) {
  var vars = query.split('&');
  var params = {};

  for (var i = 0; i < vars.length; i += 1) {
    var pair = vars[i].split('=');
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]); // Ignore duplicate URL params; assume the first instance is authoritative

    if (typeof params[key] === 'undefined') {
      params[key] = decodeURIComponent(value);
    }
  }

  return params;
};
var getVariantsFromUrl = function getVariantsFromUrl(locator) {
  try {
    var search = locator.split('?')[1] || '';
    var searchParams = parseQueryString(search);
    var forcedVariantsEncoded = searchParams.oneXPForcedExperiments;

    if (!forcedVariantsEncoded) {
      return undefined;
    }

    var stringFromData = typeof window !== 'undefined' ? atob(forcedVariantsEncoded) : Buffer.from(forcedVariantsEncoded, 'base64').toString();
    var stringifiedObject = decodeURIComponent(stringFromData.split('').map(function (character) {
      return "%".concat("00".concat(character.charCodeAt(0).toString(16)).slice(-2));
    }).join(''));
    var parsed = JSON.parse(stringifiedObject);
    return _typeof(parsed) === 'object' ? parsed : undefined;
  } catch (e) {
    return undefined;
  }
};
var formatForcedVariants = function formatForcedVariants(experimentData) {
  var experimentsArray = [];
  Object.keys(experimentData).forEach(function (experiment) {
    var id;
    var experimentValues = Object.keys(experimentData[experiment]);
    var dimensions = [];
    experimentValues.forEach(function (name) {
      var variant = experimentData[experiment][name]; // eslint-disable-next-line no-unused-expressions

      name === 'experimentId' ? id = variant : dimensions.push({
        name: name,
        variant: variant
      });
    });
    experimentsArray.push({
      name: experiment,
      id: id,
      dimensions: dimensions,
      variantForced: true
    });
  });
  return experimentsArray;
};

var OneXpSdkClient =
/*#__PURE__*/
function () {
  function OneXpSdkClient(_ref) {
    var fetchClient = _ref.fetchClient,
        oneXPBaseURL = _ref.oneXPBaseURL,
        oneXPFaasURL = _ref.oneXPFaasURL;

    _classCallCheck(this, OneXpSdkClient);

    this.fetchClient = fetchClient;
    this.oneXPBaseURL = oneXPBaseURL;
    this.oneXPFaasURL = oneXPFaasURL;
    this.userIdentifier = null;
  }
  /**
   * @description Finds experiments a user is eligible for and assigns them
   * @param {Object} params
   * @param {string} params.locator The URL to detect eligible experiments on
   * @param {Object} [params.fetchOpts] Additional options to include with the fetch request
   * @param {Object} params.oneXPForcedExperiments An object representing the
   * experiments/variantsdesired. Will override the return value of the request.
   * @returns {Promise<Array<Experiment>>} An array of experiment objects
   */


  _createClass(OneXpSdkClient, [{
    key: "findVariants",
    value: function findVariants(_ref2) {
      var _this = this;

      var locator = _ref2.locator,
          oneXPForcedExperiments = _ref2.oneXPForcedExperiments,
          _ref2$experimentData = _ref2.experimentData,
          experimentData = _ref2$experimentData === void 0 ? {} : _ref2$experimentData,
          _ref2$fetchOpts = _ref2.fetchOpts,
          fetchOpts = _ref2$fetchOpts === void 0 ? {} : _ref2$fetchOpts;
      var forcedVariants = oneXPForcedExperiments || getVariantsFromUrl(locator);

      if (_typeof(forcedVariants) === 'object') {
        var formattedExperiments = formatForcedVariants(forcedVariants);
        return promisePonyfill.resolve(formattedExperiments);
      }

      var payload = {
        locator: locator
      };
      return makeRequest({
        fetchClient: this.fetchClient,
        fetchOpts: deepmerge(fetchOpts, this.userIdentifier ? {
          headers: {
            'agent-id': this.userIdentifier
          }
        } : {}),
        url: "".concat(this.oneXPBaseURL, "/variant/find"),
        payload: payload,
        experimentData: experimentData
      }).then(function (_ref3) {
        var experiments = _ref3.experiments,
            userIdentifier = _ref3.userIdentifier;

        if (userIdentifier && typeof userIdentifier === 'string' && !_this.userIdentifier) {
          _this.userIdentifier = userIdentifier;
        }

        return experiments;
      }).catch(function (e) {
        if (e.status && e.status === 404 || e.message && e.message === 'AGENT_ID_MISSING') {
          return [];
        }

        return promisePonyfill.reject(e);
      });
    }
    /**
     * @description Sends impressions for a list of experiments
     * @param {Object} params
     * @param {Array<Object>} params.experiments Array of objects with experimentID and variants
     * @returns {Promise<void>}
     */

  }, {
    key: "impressVariants",
    value: function impressVariants(_ref4) {
      var experiments = _ref4.experiments,
          _ref4$fetchOpts = _ref4.fetchOpts,
          fetchOpts = _ref4$fetchOpts === void 0 ? {} : _ref4$fetchOpts;
      // TODO: API expects an object called `variants`; this is a confusing name. `variants` is a map
      // of dimension names to values; it represents a particular group a user has been assigned to.
      var payload = experiments.map(function (_ref5) {
        var experimentId = _ref5.experimentId,
            variants = _ref5.variants;
        return {
          experimentId: experimentId,
          variants: variants
        };
      });
      return makeRequest({
        fetchClient: this.fetchClient,
        fetchOpts: fetchOpts,
        url: "".concat(this.oneXPFaasURL, "/UpdateOneXPVariantImpressed.v1"),
        payload: payload
      }).then(function () {}); // swallow the response data, since it isn't actually needed
    }
    /**
     * @description Sends an action for a particular action
     * @param {Object} params
     * @param {string} params.experimentId Identifier of the experiment to emit action on
     * @param {string} params.objectiveId Identifier of the objective that had an action
     */

  }, {
    key: "emitObjectiveAction",
    value: function emitObjectiveAction(_ref6) {
      var experimentId = _ref6.experimentId,
          objectiveId = _ref6.objectiveId,
          _ref6$fetchOpts = _ref6.fetchOpts,
          fetchOpts = _ref6$fetchOpts === void 0 ? {} : _ref6$fetchOpts;
      var payload = {
        experimentId: experimentId,
        objectiveId: objectiveId
      };
      return makeRequest({
        fetchClient: this.fetchClient,
        fetchOpts: fetchOpts,
        url: "".concat(this.oneXPFaasURL, "/CreateOneXPAction.v1"),
        payload: payload
      }).then(function () {}); // swallow the response data, since it isn't actually needed
    }
    /**
     * @description Detect when an html element/node becomes visible with the users viewport using
     * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
     * @param {Element} element The html element that you want to detect visibility
     * @param {Function} callback A function which is called when the percentage
     * of the target element is visible crosses a threshold. Will be called once.
     * @param {Number} percentVisiible A number between 0 and 1.0 represents percentage of how
     * much of the target object must be visible before firiing the callback. a value of
     * 1.0 means it must be 100% visible.
     * @param {Node} options Optional optional intersection observer options
    */
    // eslint-disable-next-line class-methods-use-this, max-params

  }, {
    key: "onElementVisible",
    value: function onElementVisible(element, callback, percentVisible, options) {
      var intObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= percentVisible) {
            callback();
            observer.disconnect();
          }
        });
      }, _objectSpread2({}, options, {
        threshold: percentVisible
      }));
      intObserver.observe(element);
    }
  }]);

  return OneXpSdkClient;
}();

var initialize = function initialize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      userProvidedFetchClient = _ref.fetchClient,
      _ref$oneXPBaseURL = _ref.oneXPBaseURL,
      oneXPBaseURL = _ref$oneXPBaseURL === void 0 ? process.env.ONE_XP_BASE_URL : _ref$oneXPBaseURL,
      _ref$oneXPFaasURL = _ref.oneXPFaasURL,
      oneXPFaasURL = _ref$oneXPFaasURL === void 0 ? process.env.ONE_XP_FAAS_URL : _ref$oneXPFaasURL;

  if (!oneXPBaseURL || typeof oneXPBaseURL !== 'string') {
    throw new Error("Invalid param oneXPBaseURL: expected string but received ".concat(oneXPBaseURL));
  }

  if (!oneXPFaasURL || typeof oneXPFaasURL !== 'string') {
    throw new Error("Invalid param oneXPFaasURL: expected string but received ".concat(oneXPFaasURL));
  }

  var fetchClient = userProvidedFetchClient || initFetchPonyfill({
    Promise: promisePonyfill
  }).fetch;
  return new OneXpSdkClient({
    fetchClient: fetchClient,
    oneXPBaseURL: oneXPBaseURL,
    oneXPFaasURL: oneXPFaasURL
  });
};

export { initialize };
